<template>
    <v-col cols="12">
        <v-input
            :rules="rules"
            :value="items.length"
            class="secret-input"
            ref="input"
        />
        <v-dialog
            :max-width="item.props.width ? item.props.width : '800px'"
            persistent
            v-model="dialog"
        >
            <v-card v-if="dialog">
                <template v-if="item.props.isFileUpload">
                    <FileUpload
                        :fieldData="item"
                        :item="editedItem"
                        :moduleKey="moduleKey"
                        :projectId="projectId"
                        :userId="userId"
                        v-on:confirm="save"
                        v-on:cancel="close"
                    />
                </template>
                <template v-else>
                    <ItemForm
                        :structureData="structureData"
                        exitLabel="Close"
                        :moduleKey="moduleKey"
                        :projectId="projectId"
                        :userId="userId"
                        v-model="editedItem"
                        v-on:cancel="close"
                        v-on:confirm="save"
                        v-on:exit="close"
                        :handleTabChange="handleTabChange"
                        :openQuestionnaire="openQuestionnaire"
                    />
                </template>
            </v-card>
        </v-dialog>
        <v-data-table
            :class="items.length ? 'count' : 'nocount'"
            :headers="computedHeaders"
            :items="items"
            :items-per-page="-1"
            :disable-sort="true"
            :no-data-text="item.props.noDataLabel"
            hide-default-footer
            style="background-color: transparent"
        >
            <template v-slot:top>
                <DataTableToolbar
                    :alert="alert"
                    :item="item"
                    :readonly="readonly || disableInsert"
                    v-on:newItem="newItem"
                />
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    :disabled="readonly"
                    small
                    class="mr-2"
                    v-if="!noEdit"
                    v-on:click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    :disabled="readonly"
                    small
                    v-if="!noDelete"
                    v-on:click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.submoduleLink="{ item }">
                <template v-if="item.submoduleText">
                    <div class="submoduleText" v-html="item.submoduleText"></div>
                </template>
                <template v-else>
                    <v-btn
                        :disabled="readonly"
                        color="primary"
                        small
                        v-on:click="handleOpenSubmodule(item)"
                    >{{ item.submoduleLink || 'Complete this Questionnaire' }}</v-btn>
                </template>
            </template>
        </v-data-table>
    </v-col>
</template>

<script>
    import FileUpload from '../data_table_forms/file-upload';
    import DataTableToolbar from './data-table-toolbar.vue';
    import { rules } from '../utilities';
    import dataTableMixins from './mixins/data-table-mixins';
    import dataTableFileMixins from './mixins/data-table-file-mixins';
    import formulaHandlerMixins from './mixins/formula-handler-mixins';

    export default {
        mixins: [dataTableMixins, dataTableFileMixins, formulaHandlerMixins],
        name: 'DataTable',
        props: {
            alert: String,
            handleTabChange: Function,
            item: Object,
            moduleKey: String,
            optional: Boolean,
            projectId: String,
            questionWidth: String,
            readonly: Boolean,
            rules: Array,
            userId: String,
            value: Array,
            openQuestionnaire: Function
        },
        components: {
            DataTableToolbar,
            FileUpload,
            ItemForm: () => import('./item-form'),
        },
        data: function () {
            return {
                hasActions: true
            };
        },
        mounted: function () {
            this.setStructure();
            // console.log(this.projectId, this.moduleKey, this.userId)
        },
        methods: {
            newItem: function () {
                this.dialog = true;
            }
        }
    }
</script>

<style scoped>
    /* The input is used for tracking items, but should not be visible */
    .secret-input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .nocount >>> .v-data-table__wrapper {
        display: none;
    }
    .submoduleText {
        color: #F1563F
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/data-table.vue